import React from 'react'
import { ContainerModal } from '../../../Styled'
import { ModalAlert2 } from './Styled'


const Alert2 = ({children, estado, setModal, justify, width, padding, height}) => {
  return (
    <>
    { estado &&
    <ContainerModal>
        <ModalAlert2 justify={justify} width={width} padding={padding} height={height}>
            {children}
        </ModalAlert2>
    </ContainerModal>
    }

    </>
  )
}

export default Alert2